<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Delete Assistant</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-3"><h2>This assistant will be deleted, this action can't be undone</h2></v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-row class="pa-2 ma-0">
                    <v-col cols=2 class="pa-2">Name</v-col><v-col cols=10 class="pa-2">{{ assistant.name }}</v-col>
                    <v-col cols=2 class="pa-2">Description</v-col><v-col cols=10 class="pa-2">{{ assistant.description }}</v-col>
                    <v-col cols=2 class="pa-2">Instructions</v-col><v-col cols=10 class="pa-2"><v-textarea v-model="assistant.instructions" rows="4" disabled dense></v-textarea></v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" small @click="deleteAssistant">Comfirm Delete</v-btn>
                <v-btn color="primary" small @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                assistant: {},
            }
        },
        methods: { 
            openDialog(assistant) {
                this.assistant = assistant;
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
            deleteAssistant() {
                this.$axios.post("ares/json/ares/syst/openai/deleteAssistants.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteAssistants",
                    },
                    deleteAssistants: [this.assistant],
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.deleteAssistants.text,
                            color: res.data.deleteAssistants.color,
                        });
                        this.$emit("updateData", "refresh");
                        this.closeDialog();
                    }
                });
            },
        }
    }
</script>